import { preparePhone } from './phone';
import { TCreateConsultingRequestRequest } from '../../../repositories/newbuilding-flat-view-order/v1/create-consulting-request';
import { ICityAds, IHhQueryParams } from '../../../types/cpa';
import { IRegion, IRequestFormValues } from '../../../types/requestForm';

export const prepareSubmitValues = (
  values: IRequestFormValues,
  cookieHhValue?: IHhQueryParams,
  cityAds?: ICityAds,
): TCreateConsultingRequestRequest => {
  return {
    phone: preparePhone(values.phone),
    regionId: (values.region as IRegion).id,
    requirements: values.requirements.trim() || undefined,
    hh: cookieHhValue || undefined,
    cityAds,
  };
};
